//Margin conventions
var margin = {top: 0, right: 18, bottom: 15, left: 95};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 90 - margin.top - margin.bottom;

var barHeight = 25;      

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0)
  .domain(["United States", "Charlotte"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .orient("bottom")
  .tickFormat(function(d) {return d + "%"; })
  .ticks(5)
  .tickSize(height); 

//Local data
var data=[{"category":"United States","num":16, "num2": 100},
          {"category":"Mecklenburg Co., NC","num":33, "num2": 100}];   
        
//Draw the chart
ready(data);

function ready(data) {

  //FORMAT data
  data.forEach(function(d) {
    d.num = +d.num;
    d.num2 = +d.num2;
  });

  //Sets the max/min for the xScale
  var maxX = d3.max(data, function(d) { return d.num2; });
  var minX = d3.min(data, function(d) { return d.num; });

  //Defines the xScale domain
  xScale.domain([0, maxX ]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis);

  d3.selectAll(".y.axis text")
    .attr("transform", "translate(-85,-1)");  

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .call(xAxis); 

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.category) + ")";
    });

  //Appends background bar   
  var bars2 = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.num2); })
    .attr("height", barHeight)
    .attr("class", "g-num2")
    .attr("transform", "translate(0,4)");   

  //Appends main bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.num); })
    .attr("height", barHeight)
    .attr("class", "g-num")
    .attr("transform", "translate(0,4)"); 
  
  //Binds data to labels
  var labelGroup = svg.selectAll("g-num")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-label-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.category) + ")";
    });

  //Appends main bar labels   
  var barLabels = labelGroup.append("text") 
    .text(function(d) {return  d.num + "%";})
    .attr("x", function(d) { return xScale(d.num) + 5;})
    .attr("y", y0.rangeBand()/1.8 ) ;
      
  //RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 0, right: 18, bottom: 15, left: 95};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.num); });

    //Update the second bars
    bars2
      .attr("width", function(d) { return xScale(d.num2); });  

    //Updates bar labels
    barLabels
      .attr("x", function(d) { xScale(d.num) + 5;})
      .attr("y", y0.rangeBand()/1.6 )

    //Updates xAxis
    xAxisGroup
      .call(xAxis);   

    //Updates ticks
    xAxis
      .scale(xScale)

    //Updates labels
    barLabels
      .attr("x", function(d) { return xScale(d.num) + 5;})
      .attr("y", y0.rangeBand()/1.8 ) ;


  };

}
